import { render, staticRenderFns } from "./UploadApp.vue?vue&type=template&id=3ccdd230&scoped=true&"
import script from "./UploadApp.vue?vue&type=script&lang=js&"
export * from "./UploadApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccdd230",
  null
  
)

export default component.exports